export const LIST_ACCOUNT_REQUEST = 'LIST_ACCOUNT_REQUEST';
export const LIST_ACCOUNT_REQUEST_SUCCESS = 'LIST_ACCOUNT_REQUEST_SUCCESS';
export const LIST_ACCOUNT_REQUEST_FAILURE = 'LIST_ACCOUNT_REQUEST_FAILURE';

export const CLEAR_ACCOUNT_LIST = 'CLEAR_ACCOUNT_LIST';